import { withAuthenticationRequired } from '@auth0/auth0-react';
import Layout from 'components/Layout';
import { Outlet } from 'react-router-dom';

function PrivateRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default withAuthenticationRequired(PrivateRoute);
